/* ============================================================
 * zg-utils.js
 *
 * @author: Botond Szasz   <bszasz@zerogrey.com>
 * @author: David Pocina   <dpocina[at]zerogrey[dot]com>
 * @author: Miguel Sanchez <msanchez[at]zerogrey[dot]com>
 *
 * ============================================================ */

// In case we forget to take out console statements.
// IE becomes very unhappy when we forget.
// Let's not make IE unhappy
(function () {
  'use strict'

  let method
  const noop = function () {}
  const methods = [
    'assert',
    'clear',
    'count',
    'debug',
    'dir',
    'dirxml',
    'error',
    'exception',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'markTimeline',
    'profile',
    'profileEnd',
    'table',
    'time',
    'timeEnd',
    'timeline',
    'timelineEnd',
    'timeStamp',
    'trace',
    'warn'
  ]
  let { length } = methods
  const console = (window.console = window.console || {})

  while (length--) {
    method = methods[length]

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop
    }
  }
})();

(function () {
  'use strict'

  const root = this

  const makeUrl = function makeUrl(params) {
    let rslt = window.SGL_JS_WEBROOT + '/' + window.SGL_JS_FRONT_CONTROLLER
    const moduleName = params.module ? params.module : ''
    const managerName = params.manager ? params.manager : moduleName
    let x

    if (window.SGL_JS_URL_STRATEGY === 'SGL_UrlParser_ClassicStrategy') {
      if (rslt.charAt(rslt.length - 1) !== '?') {
        rslt += '?'
      }

      rslt = rslt + 'moduleName=' + window.escape(moduleName) + '&managerName=' + window.escape(managerName) + '&'

      for (x in params) {
        if ((x === 'module') || (x === 'manager')) {
          continue
        }

        rslt = rslt + window.escape(x) + '=' + window.escape(params[x]) + '&'
      }
    } else {
      rslt = rslt[rslt.length - 1] === '/' ? rslt + window.escape(moduleName) + '/' + window.escape(managerName) + '/' : rslt + '/' + window.escape(moduleName) + '/' + window.escape(managerName) + '/'

      for (x in params) {
        if ((x === 'module') || (x === 'manager')) {
          continue
        }

        if (window.escape(params[x]) != 'null') {
          rslt = rslt + window.escape(x) + '/' + window.escape(params[x]) + '/'
        }
      }
    }

    return rslt
  }

  root.makeUrl = makeUrl
}).call(this);

(function ($, _) { /* global _, zgGetObjectPropertyValue */
  'use strict'

  const root = this

  /**
	 * Comparison script to sort a normal array, an array of objects or a jQuery array of DOM elements.
	 * For Objects and DOM arrays it is required to provide a property to sort by.
	 *
	 * @param {!Object} primary
	 * @param {?Object} secondary
	 *
	 * Objects structure:
	 *   dir - {number} - if is a positive number sorts ascending, if negative sorts descending. Defaults to 1
	 *   attr - {string} - value to use for sorting. for DOM elements can be a attribute or data-attribute and for
	 *     objects a property
	 *   pattern - {Array} - pattern to use for sorting
	 *   avoidNumbersOnTop - {boolean} - do not sort numbers before text
	 *
	 */
  const zg_sortElements = function zg_sortElements(primary, secondary) {
    const dir = primary.dir || 1

    const defaultPatterns = [
      ['3xs', '3XS', 'xxxs', 'XXXS', '2xs', '2XS', 'xxs', 'XXS', 'xs', 'XS', 's', 'S', 'm', 'M', 'l', 'L', 'xl', 'XL', 'xxl', 'XXL', '2xl', '2XL', 'xxxl', 'XXXL', '3xl', '3XL']
    ]

    const sortByPattern = function sortByPattern(aa, bb, pattern) {
      if (_.contains(pattern, aa) && !_.contains(pattern, bb)) {
        return -1
      }

      if (!_.contains(pattern, aa) && _.contains(pattern, bb)) {
        return 1
      }

      if (_.contains(pattern, aa) && _.contains(pattern, bb)) {
        return (($.inArray(aa, pattern) - $.inArray(bb, pattern)))
      }

      return 0
    }

    return function (a, b) {
      const aa = zgGetObjectPropertyValue(a, primary.attr)
      const bb = zgGetObjectPropertyValue(b, primary.attr)
      let	res = 0

      if (aa === bb) {
        // a and b are equal. try to use the secondary sorting method
        if (secondary) {
          const secAr = [a, b].sort(zg_sortElements(secondary))
          res = Number(secondary.dir || 1) * (zgGetObjectPropertyValue(secAr[0], secondary.attr) === zgGetObjectPropertyValue(a, secondary.attr) ? -1 : 1)
        }

        return res
      }

      if (aa && _.isNull(bb)) {
        return (Number(dir))
      }

      if (bb && _.isNull(aa)) {
        return -(Number(dir))
      }

      // try to sort the elements using the user defined pattern
      if (primary.pattern) {
        res = sortByPattern(aa, bb, primary.pattern)

        if (res !== 0) {
          return (Number(dir)) * res
        }
      }

      // try to sort the elements using the predefined pattern
      for (const defaultPattern of defaultPatterns) {
        res = sortByPattern(aa, bb, defaultPattern)

        if (res !== 0) {
          return (Number(dir)) * res
        }
      }

      // ordering numbers
      if (!isNaN(aa) && !isNaN(bb)) {
        return ((Number(dir)) * ((Number(aa)) - (Number(bb))))
      }

      if (!primary.avoidNumbersOnTop) {
        // numbers should be on top
        if (!isNaN(aa) && isNaN(bb)) {
          return -(Number(dir))
        }

        if (isNaN(aa) && !isNaN(bb)) {
          return (Number(dir))
        }
      }

      // this function (if available) will sort the elements even if they have non ASCII characters.
      if (aa && _.isFunction(aa.localeCompare)) {
        return ((Number(dir)) * aa.localeCompare(bb))
      }

      // fallback
      res = 0

      if (aa < bb) {
        res = -1
      } else if (aa > bb) {
        res = 1
      }

      return (Number(dir) * res)
    }
  }
  // Usage:
  // var $elements = $( selector )
  // $elements.sort( zg_sortElements( {
  //		dir: [ 1 | -1 ],
  //		attr: [ "attribute" | null ],
  //		pattern: [array],
  //		avoidNumbersOnTop: [true|false]
  //	} ));
  // $elements.parent().append( $elements );

  /**
	 *
	 *
	 * @param {Object} values
	 * @param {string} [prop]
	 * @param {string} [pattern]
	 *
	 * @returns {Array}
	 */
  const zgSortObjectByProp = function zgSortObjectByProp(values, prop, pattern) {
    let key
    const array = []

    for (key in values) {
      if (values.hasOwnProperty(key)) {
        // include the key as a property and add the object to the array
        values[key].key = key
        array.push(values[key])
      }
    }

    array.sort(window.zg_sortElements({
      attr: prop || 'name',
      avoidNumbersOnTop: true,
      pattern
    }))

    return array
  }

  root.zg_sortElements = zg_sortElements
  root.zgSortObjectByProp = zgSortObjectByProp
}).call(this, jQuery, _);

(function ($) {
  'use strict'

  $(() => {
    // Shorthand to print the current page
    $(document).on('click', '[data-role="print"]', () => {
      window.print()
    })

    // Don't allow the user to click multiple times on those links
    $('[data-prevent-double-click="true"]').on('click', function () {
      $(this).off('click')
      $(this).on('click', () => {
        return false
      })
      // When the user is waiting is better hide the body
      $('body').addClass('loading')
    })

    // Don't allow the user to multi submit a form
    $('[data-prevent-double-submit="true"]').on('submit', function () {
      const $this = $(this)

      if ($this.data('zgValidator') && !$this.data('zgValidator').validate()) {
        return false
      }

      $(':submit', this).attr('disabled', 'disabled')
      // When the user is waiting is better hide the body
      $('body').addClass('loading')
    })
  })
})(jQuery)
